import type { MessageDescriptor } from 'react-intl-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import messages from './messages';

export const MAX_FULL_NAME_LENGTH_IN_CHARS = 255;
const MAX_PASSWORD_LENGTH_IN_CHARS = 72;
const OLD_MAX_PASSWORD_LENGTH_IN_CHARS = 100;
export const MIN_PASSWORD_LENGTH_IN_CHARS = 8;

export const getMaxPasswordLength = (): number =>
    FeatureGates.checkGate('banana-4348-portal-signup-password-len-reduction')
        ? MAX_PASSWORD_LENGTH_IN_CHARS
        : OLD_MAX_PASSWORD_LENGTH_IN_CHARS;

export interface ValidationErrors {
    fullNameError?: MessageDescriptor;
    passwordError?: MessageDescriptor;
}

export function validateAll(fullName: string, password: string): ValidationErrors | undefined {
    const fullNameError = validateFullName(fullName);
    const passwordError = validatePassword(password);

    if (fullNameError || passwordError) {
        return {
            fullNameError,
            passwordError,
        };
    }

    return undefined;
}

export function validateFullName(fullName: string): MessageDescriptor | undefined {
    const trimmedFullName = fullName.trim();
    if (trimmedFullName.length === 0) {
        return messages.fullNameMissingError;
    }
    if (trimmedFullName.length > MAX_FULL_NAME_LENGTH_IN_CHARS) {
        return messages.fullNameTooLongError;
    }

    return undefined;
}

export function validatePassword(password: string): MessageDescriptor | undefined {
    if (password.trim().length === 0) {
        return messages.passwordMissingError;
    }
    if (password.length < MIN_PASSWORD_LENGTH_IN_CHARS) {
        return messages.passwordTooShortError;
    }

    if (password.length > getMaxPasswordLength()) {
        return messages.passwordTooLongError;
    }

    return undefined;
}
